import template from './price-rent-with-period.jade';
import paymentPeriodOptions from '../../../enums/payment-period';

export default angular
    .module('cian.addForm.priceRentWidthPeriod', [])
    .directive('cianAfPriceAndDealTermsPriceRentWithPeriod', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.ad.bargainTerms = this.ad.bargainTerms || {};
            this.periodOptions = paymentPeriodOptions;
            if (!this.ad.bargainTerms.paymentPeriod) {
                this.ad.bargainTerms.paymentPeriod = this.periodOptions[0].value;
            }
        },
        controllerAs: 'priceRentWithPeriod',
        template,
    }))
    .name;
